import { useEffect } from 'react';

export const LogConfig = (props) => {
    const { children } = props;
    const isLocal = window.location.hostname === 'localhost';
    useEffect(() => {
        if (!isLocal && !(window as any)._errorFunc) {
            (window as any)._errorFunc = console.error;

            console.error = (...params) => {
                const newParams = params.filter((p) => typeof p === 'object' && !p.message.includes('__HIDDEN__'));
                if (newParams.length > 0) {
                    (window as any)._errorFunc(...newParams);
                }
            };
        }
        // eslint-disable-next-line
    }, []);

    return <>{children}</>;
};
